import produce from 'immer';
import {HIDE_OVERLAY, SHOW_OVERLAY} from 'actions/uiStateActions';

// The initial state of the App
export const initialState = {
  showOverlay: false,
  overlayType: '',
};

/* eslint-disable default-case, no-param-reassign */
const uiStateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SHOW_OVERLAY:
        draft.showOverlay = true;
        draft.overlayType = action.overlayType;
        draft.overlayData = action.overlayData;
        break;

      case HIDE_OVERLAY:
        draft.showOverlay = false;
        draft.overlayType = '';
        break;
    }
  });

export default uiStateReducer;
